import { Injectable, Injector, ErrorHandler  } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpResponse, HttpErrorResponse, HttpHandler, HttpEvent } from '@angular/common/http';
  
import { Observable } from 'rxjs';
import { tap, timeout } from 'rxjs/operators';

import { Settings, SettingsService } from '../../../settings';
  
@Injectable()
export class ApplicationHttpInterceptor implements HttpInterceptor {

  settings: Settings;

  constructor(
    private injector: Injector
  ) {
    var settingsService = this.injector.get(SettingsService);

    this.settings = settingsService.get();
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request); // skip for now 11.02.2021


    //const requestTimeout = 10000;
    const requestTimeout: number = Number(request.headers.get('timeout')) || this.settings.longRunningRequestTimeout;

    return next.handle(request)
      .pipe(
      //.timeout(new Date("December 17, 2020 03:24:00"))
        timeout(requestTimeout
          //,
        //new Error('Timeout expired.')
        //console.log('Timeout expired.')
        ),
        tap(response => {
          if (response instanceof HttpResponse) {
            let body = response.body;
            if (body.Error || body.errorMessage) {
              //this.toasterService.pop('error', 'Error ' + response.Code, response.Message);
              console.log('An error occurred:', body.Error || body.errorMessage);
            }
          }
        }, (err: any) => {
          if (err instanceof HttpErrorResponse) {
            const appErrorHandler = this.injector.get(ErrorHandler);
            appErrorHandler.handleError(err);
          }
        })
    );
  }
}
